import { injectIntl } from 'react-intl';
import { Dialog, ScreenMessagePanelContainer, Label, ButtonStandard, ButtonLight, formatMessage } from 'cw-ui-core';
import css from './DeleteRoleDialog.scss';
import Locale from 'src/i18n';
import React from 'react';

export const DELETE_ROLE_DIALOG = 'DELETE_ROLE_DIALOG';

const DeleteRoleDialog = props => {
    const dialogButtons = [
        <ButtonLight
            key="cancel"
            automationName="cancel"
            className={css.cancelButton}
            value={formatMessage(Locale.cancel)}
            onClick={props.onCancelButtonClick}
        />,
        <ButtonStandard
            key="delete"
            automationName="delete"
            className={css.deleteButton}
            value={formatMessage(Locale.delete)}
            onClick={props.onDeleteButtonClick}
        />,
    ];

    return (
        <Dialog dialogId={DELETE_ROLE_DIALOG} header={formatMessage(Locale.deleteRole)} buttons={dialogButtons}>
            <div className={css.wrap}>
                <ScreenMessagePanelContainer className={css.screenMessage} screenKey={DELETE_ROLE_DIALOG} />
                <Label value={formatMessage(Locale.deleteRoleConfirmation)} />
            </div>
        </Dialog>
    );
};

export default injectIntl(DeleteRoleDialog);
